import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BoxFiltroPaqueteServicio } from "./BoxFiltroPaqueteServicio";
import { useBox } from "../FacturacionMaquinaria/useBox";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { GetKey } from "../FacturacionMaquinaria/GetContainer";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { TablaPowergard } from "./TablaPowergard";
import { TablaPolizaMantenimiento } from "./TablaPolizaMantenimiento";
import { Button } from "@mui/material";
import { LoaderScreen } from "../../components/LoaderScreen";
import ModalAgregarPowergard from "./ModalAgregarPowergard";
import ModalAgregarPolizaMantenimiento from "./ModalAgregarPolizaMantenimiento";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { number } from "echarts";
import { useSelector } from "react-redux";

export const PaqueteServicioMainScreen = () => {
  const history = useHistory();
  const location = useLocation();

  const state = location.state;

  const { roles } = useSelector((state) => state.sesion);

  const fechaActual = new Date();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const rolesPermitidosPowergard = ["REWR", "EPSP"];
  const rolesPermitidosMantenimiento = ["REWR", "EPSM"];

  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  const ejercicioActual = fechaActual.getFullYear();
  const mesActual = fechaActual.getMonth() + 1;

  const [idPaquete, setIdPaquete] = useState(-1);
  const [idPoliza, setIdPoliza] = useState(-1);

  const [data, setData] = useState([]);
  const [dataMantenimiento, setDataMantenimiento] = useState([]);

  const [mostrarTPowergard, setMostrarTPowergard] = useState(true);
  const [mostrarTMantenimiento, setMostrarTMantenimiento] = useState(false);

  const [permisoEliminarPowergard, setPermisoEliminarPowergard] =
    useState(false);
  const [permisoEliminarMantenimiento, setPermisoEliminarMantenimiento] =
    useState(false);

  const [titulo, setTitulo] = useState("PAQUETE DE SERVICIOS");

  //Modales
  const [mostrarMPowergard, setMostrarMPowergard] = useState(false);
  const [mostrarMMantenimiento, setMostrarMMantenimiento] = useState(false);

  const initialStateboxfiltros = () => {
    const datosFiltro = localStorage.getItem("DatosFiltro");
    if (datosFiltro) {
      const filtroParsed = JSON.parse(datosFiltro);

      return {
        ejercicioinicio: filtroParsed.ejercicioinicio || ejercicioActual,
        periodoinicio: filtroParsed.periodoinicio || "1",
        ejerciciofin: filtroParsed.ejerciciofin || ejercicioActual,
        periodofin: filtroParsed.periodofin || mesActual,
        tipoRegistro: state === "GE" ? "P" : state === "PM" ? "M" : "P",
        pv: {
          adr: filtroParsed.pv.adr || [],
          sucursal: filtroParsed.pv.sucursal || [],
          vendedor: filtroParsed.pv.vendedor || [],
        },
      };
    } else {
      return {
        ejercicioinicio: ejercicioActual,
        periodoinicio: "1",
        ejerciciofin: ejercicioActual,
        periodofin: mesActual,
        tipoRegistro: state === "GE" ? "P" : state === "PM" ? "M" : "P",
        pv: { adr: [], sucursal: [], vendedor: [] },
      };
    }
  };

  const [boxstate, setBoxState] = useBox(initialStateboxfiltros());

  const onHome = () => {
    if (state === "GE" || state === "PM") {
      history.push("/Ventas/DashboardScorecardGerente");
    } else {
      history.push("/Ventas/Main");
    }
  };

  useEffect(() => {
    BoxClick();

    if (roles.some((rol) => rolesPermitidosPowergard.includes(rol.idrol))) {
      setPermisoEliminarPowergard(true);
    }

    if (roles.some((rol) => rolesPermitidosMantenimiento.includes(rol.idrol))) {
      setPermisoEliminarMantenimiento(true);
    }
  }, []);

  const BoxClick = () => {
    return new Promise((res, req) => {
      setLoader({ ...loader, mostrar: true });
      if (
        boxstate.ejercicioinicio === undefined ||
        boxstate.ejercicioinicio === null ||
        boxstate.ejercicioinicio === "" ||
        boxstate.ejercicioinicio === "0" ||
        boxstate.ejercicioinicio === 0
      ) {
        req("Favor de agregar el ejercicio de inicio");
        return;
      }
      if (
        boxstate.periodoinicio === undefined ||
        boxstate.periodoinicio === null ||
        boxstate.periodoinicio === "" ||
        boxstate.periodoinicio === "0" ||
        boxstate.periodoinicio === 0
      ) {
        req("Favor de agregar el periodo de inicio");
        return;
      }
      if (
        boxstate.ejerciciofin === undefined ||
        boxstate.ejerciciofin === null ||
        boxstate.ejerciciofin === "" ||
        boxstate.ejerciciofin === "0" ||
        boxstate.ejerciciofin === 0
      ) {
        req("Favor de agregar el ejercicio fin");
        return;
      } else if (
        Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
      ) {
        req("El ejercicio de inicio debe ser menor o igual al ejercicio final");
        return;
      }
      if (
        boxstate.periodofin === undefined ||
        boxstate.periodofin === null ||
        boxstate.periodofin === "" ||
        boxstate.periodofin === "0" ||
        boxstate.periodofin === 0
      ) {
        req("Favor de indicar el periodo final");
        return;
      } else if (
        Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
        Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
      ) {
        req("El periodo de inicio no puede ser mayor al periodo fin");
        setLoader({ ...loader, mostrar: true });
        return;
      }

      var region = GetKey(boxstate.pv.adr, ["idEstado"]);

      if (region === undefined || region === null || region === "") {
        region = "0";
      }

      var sucursales = GetKey(boxstate.pv.sucursal, ["idSucursal"]);

      if (
        sucursales === undefined ||
        sucursales === null ||
        sucursales === ""
      ) {
        sucursales = "0";
      }

      var vendedores = GetKey(boxstate.pv.vendedor, ["idvendedor"]);

      if (
        vendedores === undefined ||
        vendedores === null ||
        vendedores === ""
      ) {
        vendedores = "0";
      }

      const fechainicio = new Date(
        boxstate.ejercicioinicio,
        Number(boxstate.periodoinicio) - 1,
        "01",
      );
      const fechafin = new Date(
        boxstate.ejerciciofin,
        Number(boxstate.periodofin) - 1,
        "01",
      );
      if (boxstate.tipoRegistro === "P") {
        request
          .get(
            `Powergard/Listado?region=${region}&sucursal=${sucursales}&vendedor=${vendedores}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicioFin=${boxstate.ejerciciofin}&periodoFin=${boxstate.periodofin}`,
          )
          .then((result) => {
            setLoader({ ...loader, mostrar: false });
            setData(result);
            setDataMantenimiento([]);
            setMostrarTPowergard(true);
            setMostrarTMantenimiento(false);
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("SCORECARD", JSON.stringify(error), "warning");
          });
      }
      if (boxstate.tipoRegistro === "M") {
        request
          .get(
            `PolizaMantenimiento/Listado?region=${region}&sucursal=${sucursales}&vendedor=${vendedores}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicioFin=${boxstate.ejerciciofin}&periodoFin=${boxstate.periodofin}`,
          )
          .then((result) => {
            setLoader({ ...loader, mostrar: false });
            setData([]);
            setDataMantenimiento(result);
            setData([]);

            setMostrarTPowergard(false);
            setMostrarTMantenimiento(true);
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("SCORECARD", JSON.stringify(error), "warning");
          });
      }

      const tituloP =
        boxstate.tipoRegistro === "P"
          ? `POWERGARD ${Number(boxstate.periodoinicio) === Number(boxstate.periodofin) ? "" : "- " + meses[boxstate.periodoinicio - 1]} ${Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) ? "" : boxstate.ejercicioinicio} - ${meses[boxstate.periodofin - 1]} ${boxstate.ejerciciofin}`
          : boxstate.tipoRegistro === "M"
            ? `POLIZA MANTENIMIENTO ${Number(boxstate.periodoinicio) === Number(boxstate.periodofin) ? "" : "- " + meses[boxstate.periodoinicio - 1]} ${Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) ? "" : boxstate.ejercicioinicio} - ${meses[boxstate.periodofin - 1]} ${boxstate.ejerciciofin}`
            : "PAQUETE SERVICIOS";

      setTitulo(tituloP);
    });
  };

  const onEliminar = (id, tipo) => {
    Swal.fire({
      title: "¿Eliminar registro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        if (tipo === "powergard") {
          onEliminarPowegard(id);
        } else if (tipo === "mantenimiento") {
          onEliminarPoliza(id);
        }
      }
    });
  };

  const onEliminarPowegard = (id) => {
    request
      .get(`Powergard/Eliminar?idpowergard=${id}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        Swal.fire({
          title: "POWERGARD",
          text: "Registro eliminado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });

        BoxClick();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ELIMINAR POWERGARD", JSON.stringify(error), "warning");
      });
  };

  const onEliminarPoliza = (id) => {
    request
      .get(`PolizaMantenimiento/Eliminar?idpoliza=${id}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        Swal.fire({
          title: "POLIZA MANTENIMIENTO",
          text: "Registro eliminado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });

        BoxClick();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ELIMINAR POWERGARD", JSON.stringify(error), "warning");
      });
  };

  const onGeneraExcel = () => {
    var region = GetKey(boxstate.pv.adr, ["idEstado"]);

    if (region === undefined || region === null || region === "") {
      region = "0";
    }

    var sucursales = GetKey(boxstate.pv.sucursal, ["idSucursal"]);

    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }

    var vendedores = GetKey(boxstate.pv.vendedor, ["idvendedor"]);

    if (vendedores === undefined || vendedores === null || vendedores === "") {
      vendedores = "0";
    }

    // return;
    setLoader({ ...loader, mostrar: true });
    if (boxstate.tipoRegistro === "P") {
      request
        .get(
          `Powergard/ImprimirExcel?region=${region}&sucursal=${sucursales}&vendedor=${vendedores}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicioFin=${boxstate.ejerciciofin}&periodoFin=${boxstate.periodofin}`,
        )
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
        });
    } else if (boxstate.tipoRegistro === "M") {
      request
        .get(
          `PolizaMantenimiento/ImprimirExcel?region=${region}&sucursal=${sucursales}&vendedor=${vendedores}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicioFin=${boxstate.ejerciciofin}&periodoFin=${boxstate.periodofin}`,
        )
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
        });
    }
  };

  const onAgregar = (id) => {
    if (boxstate.tipoRegistro === "P") {
      setIdPaquete(id);
      setMostrarMPowergard(true);
    } else if (boxstate.tipoRegistro === "M") {
      setIdPoliza(id);
      setMostrarMMantenimiento(true);
    } else {
      return;
    }
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  // console.log(boxstate)
  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"filtro-scorecard-asesores-table"}
    >
      <LoaderScreen loader={loader} />

      <ModalAgregarPowergard
        updatedata={BoxClick}
        idpowergard={idPaquete}
        setIdPaquete={setIdPaquete}
        onClose={() => setMostrarMPowergard(false)}
        open={mostrarMPowergard}
      />
      <ModalAgregarPolizaMantenimiento
        updatedata={BoxClick}
        idpoliza={idPoliza}
        setIdPoliza={setIdPoliza}
        onClose={() => setMostrarMMantenimiento(false)}
        open={mostrarMMantenimiento}
      />
      <div className="paquete-servicio-actions">
        <div
          className="dash-tabla-scorecard-gerente-actions-regresar"
          onClick={() => onHome()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <BoxFiltroPaqueteServicio
          boxState={boxstate}
          onBoxChange={setBoxState}
          BoxClick={BoxClick}
          datoslocal={initialStateboxfiltros()}
          // subtitulo={state.subtitulo}
          titulo_filtro="PAQUETES DE SERVICIO"
        ></BoxFiltroPaqueteServicio>
        <div className="buttons">
          <button className="excel" onClick={onGeneraExcel}>
            <i className=" icon-file-excel" /> <ArrowCircleDownIcon /> Excel
          </button>

          {permisoEliminarMantenimiento && (
            <div className="paquete-servicio-boton-agregar-container">
              <Button
                variant="contained"
                className="lineas-scorecard-agregar-nueva-linea"
                onClick={() => onAgregar(-1)}
              >
                <AddCircleOutlineIcon />
                Agregar
              </Button>
            </div>
          )}
        </div>
      </div>

      <div>
        {mostrarTPowergard === true ? (
          <TablaPowergard
            info={data}
            onAgregar={onAgregar}
            onEliminar={onEliminar}
            permisoEliminar={permisoEliminarPowergard}
          />
        ) : mostrarTMantenimiento === true ? (
          <TablaPolizaMantenimiento
            data={dataMantenimiento}
            onAgregar={onAgregar}
            onEliminar={onEliminar}
            permisoEliminar={permisoEliminarMantenimiento}
          />
        ) : (
          <div>Sin Datos</div>
        )}
      </div>
    </PlantillaScreen>
  );
};
